// Components
import { Typography, Skeleton } from '@mui/material'
import { SettingsItem } from '.'
import { nothing } from '$helper/functions/utils'

interface Props {
  text: string
  secondaryText: string
  onClick: () => any
}

export function SettingsItemWithText({
  text,
  secondaryText,
  onClick = nothing,
}: Props) {
  return (
    <SettingsItem
      text={text}
      secondaryContent={
        secondaryText ? (
          <Typography color="secondary" variant="subtitle3">
            {secondaryText}
          </Typography>
        ) : (
          <Skeleton width={50} />
        )
      }
      onClick={onClick}
    />
  )
}
